export default {
    user: {
        create: {
            title: "Nieuwe gebruiker",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Vul e-mail in"
                },
                name: {
                    label: "Naam",
                    placeholder: "Vul naam in"
                },
                country: {
                    label: "Land",
                    placeholder: "Vul land in"
                },
                approval_manager_email: {
                    label: "E-mailadres van de manager",
                    placeholder: "Vul manager e-mailadres in",
                    errors: {
                        different: "Het e-mailadres van de goedkeuringsmanager moet verschillen van het e-mailadres van de gebruiker"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Indienen",
                    processing: "Indienen"
                },
                cancel: {
                    text: "Annuleren"
                }
            }
        },
        country: {
            title: "Land van gebruiker",
            header: "{email} heeft geen land geselecteerd. Selecteer het land.",
            model: {
                country: {
                    label: "Land",
                    placeholder: "Vul land in"
                }
            },
            cta: {
                submit: {
                    text: "Indienen",
                    processing: "Indienen"
                },
                cancel: {
                    text: "Annuleren"
                }
            }
        }
    }
}